import { Row, Col, Divider, Table, Tag } from "antd";
import {
  DashboardOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "./cartop.css";

import { FormattedMessage, useIntl } from "react-intl";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import Typography from "../Typography";
import { COLORS } from "../../constants/Colors";
import _ from "lodash";
import { calc } from "antd/es/theme/internal";

const CardLeftHome = (props) => {
  const { queueList, handleChange } = props;
  const isDesktop = useIsDesktop();
  const textTitle =isDesktop ? '13px' : '13px'
  const lang = localStorage.getItem("lang");

  console.log('queueList',queueList);
  

  const columns = [
    {
      title: (
        <Typography className='pl-1' isBold color={COLORS.Dark} size={textTitle}>
          <FormattedMessage
            id="HomeParkingNo"
            defaultMessage="ช่องจอด เลขตู้"
          />
        </Typography>
      ),
      dataIndex: "assetDetail.joinNameSerial",
      key: "assetDetail.joinNameSerial",
      width: isDesktop ? 200 : 180,
      sorter: true,
      render: (text, record ) => <div className="pl-1">{_.get(record, "assetDetail.joinNameSerial")}</div>
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={textTitle} textAlign={'center'}>
          <FormattedMessage
            id="HomeParkingQueueWaiting"
            defaultMessage="คิวที่รอส่ง"
          />
        </Typography>
      ),
      dataIndex: "queueLeft",
      key: "queueLeft",
      align: "center",
      width: isDesktop ? 150 : 120,
      render: (text, record, index) => (
        <div className="pl-1">{_.get(record, "queueLeft")}</div>
      ),
    },
    {
      title: (
        <Typography isBold color={COLORS.Dark} size={textTitle}>
          <FormattedMessage id="HomeParkingStatus" defaultMessage="สถานะ" />
        </Typography>
      ),
      dataIndex: "status",
      key: "status",
      width: isDesktop ? 150 : 100,
      render: (text, record, index) => (
        <Tag className="tag-queue-right" color={_.get(record, "assetDetail.status.detail.color")}>
          <Typography
            className={isDesktop ? "px-2 py-1" : 'px-0 py-1'}
            isBold
            color={COLORS.White}
            size={isDesktop ?"13px": '12px'}
            textAlign={"center"}
          >
            {lang === "EN"
              ? _.get(record, "assetDetail.status.detail.EN")
              : _.get(record, "assetDetail.status.detail.TH")}
          </Typography>
        </Tag>
      ),
    },
  ];

  const data = [
    {
      queueNo: "32",
      status: "กำลังส่ง",
      parkNo: "001 01-0001",
    },
    {
      queueNo: "32",
      status: "กำลังส่ง",
      parkNo: "001 01-0001",
    },
    {
      queueNo: "32",
      status: "กำลังส่ง",
      parkNo: "001 01-0001",
    },
  ];

  const parkingContent = (
    <div
      style={{
        borderRadius: "8px",
        backgroundColor: "white",
        width: "100%",
        height: isDesktop? 'calc(100vh - 255px)' : undefined,
      }}
    >
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <Row style={{ marginTop: "0px", padding: "16px",
       }}>
          <Col span={12}>
            <Typography
              className="pt-3 pb-1 px-1"
              isBold
              color={COLORS.Dark}
              size={"16px"}
            >
              <FormattedMessage
                id="HomeParkingTitleSpace"
                defaultMessage="ช่องจอด"
              />
            </Typography>
          </Col>
        </Row>
        <Divider className="m-0" />
        <div style={{ padding: "16px",height: isDesktop? 'calc(100vh - 348px)' : undefined, overflowY: 'auto', }}>
          <Table columns={columns} dataSource={queueList} pagination={false} scroll={{x: _.sumBy(columns,'width') }} onChange={handleChange}/>
        </div>
      </div>
    </div>
  );

  return parkingContent;
};

export default CardLeftHome;
